import {Module} from '@nestjs/common';
import {AgentController} from './agent.controller';
import {AgentService} from './agent.service';
import {McpModule} from '../mcp/mcp.module';

/**
 * Agent 核心调度模块
 */
@Module({
  imports: [McpModule],
  controllers: [AgentController],
  providers: [AgentService],
  exports: [AgentService],
})
export class AgentModule {}
